import { render, staticRenderFns } from "./MapSizeInput.vue?vue&type=template&id=24df60e3&lang=pug&"
import script from "./MapSizeInput.vue?vue&type=script&lang=js&"
export * from "./MapSizeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapSizeInput.vue"
export default component.exports